module.exports = __webpack_public_path__ + "img/course_Image_eight.d9dc6227.png";